import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { apiAffiliatesGet } from '../../api/api-affiliates';
import { TourTypeContext } from '../../contexts/tour-type-context';
import { FontAwesomeIcon, PageTitle, Table, TableCell, TableRow } from '../common';
import { listPageActions } from './page-actions';

const AffiliateList = () => {
    const [data, setData] = useState([]);
    const { displayType } = useParams();
    const { tourTypeId } = useContext(TourTypeContext);
    const [anyDisabled, setAnyDisabled] = useState(false);

    const LoadData = useCallback(async () => {
        setData(await apiAffiliatesGet(tourTypeId));
    }, [tourTypeId]);

    useEffect(() => {
        LoadData();
    }, [LoadData]);

    useEffect(() => {
        setAnyDisabled(data.filter((x) => x.isDisabled).length > 0);
    }, [data]);

    const toDisplay = () => {
        if (displayType === 'disabled') {
            return data.filter((x) => x.isDisabled);
        } else {
            return data.filter((x) => !x.isDisabled);
        }
    };

    return (
        <div className="max-w-screen-lg my-2 sm:m-4 sm:rounded-lg shadow-md bg-white sm:px-4 py-4 md:mx-auto">
            <PageTitle title="Affiliates" actions={listPageActions(displayType, anyDisabled)} />
            <Table>
                <thead>
                    <tr>
                        <TableCell text="Name" header />
                        <TableCell text="Company" header />
                        <TableCell header />
                        <TableCell header />
                        <TableCell text="" header />
                    </tr>
                </thead>

                <tbody>
                    {toDisplay().map((item, key) => (
                        <TableRow key={key} rowNum={key}>
                            <TableCell>
                                {item.affiliateName}
                                {item.isDisabled ? ' (Disabled)' : ''}
                            </TableCell>
                            <TableCell>{item.companyId}</TableCell>
                            <TableCell>
                                {(item.codes || []).filter((x) => !x.expiryDate).length > 0 && (
                                    <div className="my-1">
                                        <FontAwesomeIcon icon="line-columns fa-fw" title="Affiliate Codes" />
                                        {(item.codes || []).filter((x) => !x.expiryDate).length}
                                    </div>
                                )}
                            </TableCell>
                            <TableCell>
                                {item.viewOwnBookings && (
                                    <div className="my-1">
                                        <FontAwesomeIcon icon="book-reader fa-fw" title="View Own Bookings" />
                                    </div>
                                )}
                            </TableCell>
                            <TableCell action>
                                <Link to={`/affiliate/${item.id}`}>
                                    <FontAwesomeIcon icon="edit" title="Edit" />
                                </Link>
                            </TableCell>
                        </TableRow>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default AffiliateList;
